import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  public email: string;
  public password: string;

  constructor(
    private _auth: AuthService,
    private _router: Router,
    private _userService: UserService,
    private _glService: GlobalService
  ) { }

  public login() {
    this._auth.loginUser(this.email, this.password).subscribe(res => {
      this._auth.handleTokenResponse(res);
      this._userService.getUser().subscribe(user => {
        localStorage.setItem('user', JSON.stringify(user));
        this._glService.user = user;
        this._router.navigate(['overview']);
      });
    }, () => {
      console.log('Invalid login.');
    });
  }
}
